.kdx-basic-cta {
  margin: 0;
  padding: 20px 0;

  &__right {

    .row {
      flex-direction: row-reverse;
    }

    .cta-media {
      padding-right: 0;
      padding-left: 48px;
    }
  }

  [class^='col'] {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .cta-media {
    position: relative;
    padding-right: 48px;

    .img {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      height: 100%;
      width: 100%;
    }

    .play-icon {
      background: $basic_cta_play_btn_color;
      border-radius: 10px;
      width: 85px;
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  h2 {
    position: relative;
    padding-bottom: 16px;
    margin: 0 0 24px 0;

    &::after {
      content: '';
      background: $basic_cta_theme1_heading_border;
      width: 100%;
      height: 4px;
      max-width: 65px;
      position: absolute;
      top: 100%;
      left: 0;
    }
  }

  .img {
    min-height: 445px;
    height: 100%;
    width: 100%;
  }

  .ctas {
    margin: 20px 0 0 0;
    display: flex;
    align-items: center;

    button, a, .arrow-link {
      margin: 0 24px 10px 0;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  // white background theme
  &.cta-theme-1 {
    background-color: #FFF;

    .cta-media {

      .img {
        width: 100%;
        max-height: 640px;
      }
    }

    .ctas {

      .arrow-link {
        color: $basic_cta_theme1_arrow_link;

        &:hover, &:focus {
          color: #000;
        }
      }
    }
  }
  // colored background theme
  &.cta-theme-2 {
    font-weight: 600;
    background: $basic_cta_bg;
    color: $basic_cta_text_color;

    .cta-media {

      kdx-video-embed, .video-embed, .video-embed-btn, .img {
        height: 100%;
      }
    }

    .cta-content {
      padding-top: 100px;
      padding-bottom: 100px;
    }

    h2 {
      color: $basic_cta_text_color;

      &::after {
        background: $basic_cta_theme2_heading_border;
      }
    }

    a:not(.btn) {
      color: $basic_cta_text_color;
    }

    ul:not(.list-unstyled):not(.no-checkmarks) li::before {
      background-color: transparent;
    }

    .ctas {
      .btn-primary {
        background: #FFF;
        border: 1px solid #FFF;
        color: $basic_cta_theme2_mainBtn_Text;
        box-shadow: $basic_cta_theme2_btn_shadow;

        &:hover, &:focus {
          background-color: $basic_cta_theme2_mainBtn_hover;
          border-color: $basic_cta_theme2_mainBtn_hover;
          color: $basic_cta_theme2_mainBtn_hover_text;
        }
      }

      .arrow-link {
        color: $basic_cta_theme2_arrow_link;

        &:hover, &:focus {
          color: $basic_cta_theme2_arrow_link-hover;
        }
      }
    }
  }
}


@include media-breakpoint-down(lg) {
	.kdx-basic-cta {
		.cta-media {
			.img {
				background-position: 50% 20%;
        min-height: 300px;
        background-size: cover;
			}
		}
	}
}





@include media-breakpoint-down(md) {
	.kdx-basic-cta {
		margin: 24px 0;		
		@include text-size(14);
		@include line-height(22);				

		&__right {
		
			.row {		
				flex-direction: column;
			}			
		}
		.img {
			height: 300px;
			min-height: initial;
		}
		.cta-content { padding: 24px 30px; }
		.cta-media { 
			padding: 0 30px; 
		}
		.ctas {
			flex-direction: column;
		}
		// white bg theme
		&.cta-theme-1 {

			.cta-media {
				.img { height: 300px; }
			}
		}				
		// colored background theme
		&.cta-theme-2 {
			padding: 24px 0 8px 0;
			background: $basic_cta_mobile_bg;					
			
			.cta-media {
				.img { height: 300px; }
			}			
			.cta-content { padding: 24px 30px; }
		}
	}
}



@include media-breakpoint-down(sm) {
	.kdx-basic-cta {
		
		.img {
			height: 251px;
			min-height: initial;
		}
		.ctas {		

			.btn { width: 80%; }
		}
		// white bg theme
		&.cta-theme-1 {

			.cta-media {
				.img { height: 251px; }
			}
		}				
		// colored background theme
		&.cta-theme-2 {
			
			.cta-media {
				.img { height: 251px; }
			}			
		}		
	}
}
